<template>
  <div :class="more ? 'more_echart' : 'bar_Echart'">
    <div id="hatAlarm" :style="{ width: '100%', height: '100%' }"></div>
    <div class="unit" v-if="this.Xdata.length > 0">
      {{ $t('Company') }}：<i class="unit_icon"></i> {{ $t('second') }}
    </div>
    <div class="pagination" v-if="more">
      <span>{{ staticProport.currentPage }}/{{ staticProport.totalData }}</span>
      <el-pagination
        layout="prev,next"
        @current-change="handleTraceChange"
        :current-page="staticProport.currentPage"
        :page-size="staticProport.pageSize"
        :total="staticProport.totalUser"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { splitArray } from '@/util/common'
import { mapGetters } from 'vuex'
export default {
  props: {
    barWidth: {
      type: Number,
    },
    // barName: {
    //   type: String,
    // },
    hatList: {
      type: Object / Array,
    },
    more: {
      type: Boolean,
    },
  },
  data() {
    return {
      Xdata: [],
      Data: [],
      staticProport: { totalUser: 0, currentPage: 1, totalData: 0, pageSize: 16, XuserData: [], onlineData: [] },
      color: '',
      splitLineColor: '',
    }
  },
  methods: {
    // 轨迹切换分页
    handleTraceChange(val) {
      this.staticProport.currentPage = val
      this.Xdata = this.staticProport.XuserData[val - 1]
      this.Data = this.staticProport.onlineData[val - 1]
      this.getHistogram()
    },
    // 做数据截取
    arrayChunk() {
      //机构活跃度,页数向上取整
      let proportPage = Math.ceil(this.hatList.allXData.length / 16)
      // 总页数
      this.staticProport.totalUser = this.hatList.allXData.length
      this.staticProport.totalData = proportPage
      this.staticProport.XuserData = splitArray(this.hatList.allXData, 16)
      this.staticProport.onlineData = splitArray(this.hatList.allBarData, 16)
      // 第一页数据
      this.Xdata = this.staticProport.XuserData[0]
      this.Data = this.staticProport.onlineData[0]
      this.getHistogram()
    },
    // 三角柱状图
    getHistogram() {
      if (!this.more) {
        this.Xdata = this.hatList.xData
        this.Data = this.hatList.barEchartData
      }
      let minInter = Math.min.apply(null, this.Data) // 最小值
      let MAXInter = Math.max.apply(null, this.Data) // 最大值
      let splatInter = Math.ceil((MAXInter - minInter) / 2)
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('hatAlarm'))
        let colorOne = new this.$echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(255, 217, 106, 0.9)', // 0% 处的颜色
            },
            {
              offset: 0.3,
              color: 'rgba(255, 217, 106, 0.6)', // 50% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 255, 102, 0.9)', // 100% 处的颜色
            },
          ],
          false
        )
        myChart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            transitionDuration: 0, //加上这个可以防止抖动
          },
          xAxis: {
            type: 'category',
            splitNumber: 5,
            data: this.Xdata,
            axisLabel: {
              //展示角度
              // rotate: 30,
              textStyle: {
                color: this.color,
              },
              // x轴格式化，文字过多时x轴仅显示前5个字
              formatter: function(params) {
                console.log(params)
                var newParamsName = '' // 最终拼接成的字符串
                var paramsNameNumber = params.length // 实际标签的个数
                var provideNumber = 5 // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = '' // 表示每一次截取的字符串
                    var start = p * provideNumber // 开始截取的位置
                    var end = start + provideNumber
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params
                }
                //将最终的字符串返回
                return newParamsName
              },
            },
            axisLine: {
              lineStyle: {
                color: this.splitLineColor, //更改坐标轴颜色
              },
            },
            axisTick: {
              show: true,
            },
          },
          yAxis: {
            type: 'value',
            minInterval: splatInter,
            // interval: 20,
            axisLabel: {
              textStyle: {
                color: this.color,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.splitLineColor,
              },
            },
            axisLine: {
              show: false,
            },
          },
          grid: {
            x: '2%', //距离左边
            x2: '2%', //距离右边
            y: '15%', // 上距离
            y2: '8%', // 下距离
            containLabel: true,
          },
          series: [
            {
              name: this.$t('脱帽告警'),
              data: this.Data,
              type: 'pictorialBar',
              barWidth: this.barWidth, //柱图宽度
              barCategoryGap: '40%',
              symbol: 'triangle',
              z: 10,
              itemStyle: {
                color: function() {
                  return colorOne
                },
              },
            },
            // {
            //   name: 'glyph',
            //   type: 'pictorialBar',
            //   barGap: '-100%',
            //   symbolPosition: 'end',
            //   symbolSize: 50,
            //   symbolOffset: [0, '-120%'],
            // },
          ],
        })
      })
    },
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler(val) {
        if (val) {
          this.color = '#333'
          this.splitLineColor = 'rgba(210, 210, 210, 0.5)'
        } else {
          this.color = '#fff'
          this.splitLineColor = 'rgba(101, 198, 231, 0.2)'
        }
        this.getHistogram()
      },
    },
    'hatList.xData': function() {
      if (this.more) {
        this.arrayChunk()
      } else {
        this.getHistogram()
      }
    },
    more: {
      immediate: true,
      handler() {
        if (this.more) {
          this.arrayChunk()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.bar_Echart
  width: 100%
  height: 100%
  position: relative
.more_echart
  width: 100%
  height: 100%
  position: relative
  .pagination
    position absolute
    top 6%
    right 5%
    display flex
    span
      height: 30px;/*no*/
      line-height: 30px;/*no*/
      color #333
.unit_icon
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  margin-right 5px
  background: rgba(0, 255, 102, 0.6)
>>>.el-pagination button:disabled, >>>.el-pagination .btn-next, >>>.el-pagination .btn-prev
  background var(--table-pagination-bg-color)
.theme-dark
  .bar_Echart
    .pagination
      span
        color #fff
</style>
